import { Button, Field, Modal, modalWidth, ModalStyle } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { GenerateRefsOptions, REF_PREFIXES, RefType } from "shared/hubrise/utils/ref"

import { Description } from "./Styles"

interface GenerateRefsModalProps {
  refType: RefType
  onSubmit: (options: GenerateRefsOptions) => void
  close: () => void
}

const GenerateRefsModal: React.FC<GenerateRefsModalProps> = ({ refType, onSubmit, close }) => {
  const { t } = useTranslation()
  const [replaceExisting, setReplaceExisting] = React.useState(false)

  return (
    <Modal
      modalWidth={modalWidth.medium}
      onClose={close}
      renderContent={({ close }) => (
        <>
          <ModalStyle.Header>
            <ModalStyle.Title>{t("generate_refs_modal.title")}</ModalStyle.Title>
            <ModalStyle.Close onClick={close} />
          </ModalStyle.Header>

          <ModalStyle.Body>
            <Description>
              <p>{t("generate_refs_modal.description", { prefix: REF_PREFIXES[refType] })}</p>
              <p>{t("generate_refs_modal.description_example", { prefix: REF_PREFIXES[refType] })}</p>
            </Description>

            <Field.Checkbox
              value={replaceExisting}
              text={t("generate_refs_modal.replace_existing")}
              onChange={setReplaceExisting}
            />
          </ModalStyle.Body>

          <ModalStyle.Footer>
            <Button
              variant="primary"
              onClick={() => {
                onSubmit({ replaceExisting })
                close()
              }}
            >
              {t("generate_refs_modal.submit")}
            </Button>
            <Button variant="empty" onClick={close}>
              {t("general.cancel")}
            </Button>
          </ModalStyle.Footer>
        </>
      )}
    />
  )
}

export default GenerateRefsModal
